import { useState } from "react"

/**
 * #163 (Marlene, 06.10.2026): „hier steht jetzt beantwortet und in grün
 * erledigt, aber ich sehe die Antwort nicht".
 *
 * Die Antwort ging über das Portal raus — ihre Kopie aus „Gesendete Objekte"
 * steht aber in keinem Verlauf dieser Mail (früher ohne Bezug gesendet, dann
 * über den Betreff einem anderen Verlauf zugeordnet). Das Backend liefert dann
 * Sendezeit und gesendeten Text; hier stehen sie direkt an der Mail, statt
 * „beantwortet" ohne Antwort stehen zu lassen.
 */
export type AntwortAusserhalb = { gesendet_am: string; text: string }

function zeitpunkt(iso: string): string {
  const d = new Date(iso)
  if (isNaN(d.getTime())) return ""
  return d.toLocaleString("de-DE", {
    day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
  }) + " Uhr"
}

export function AntwortAusserhalbVerlauf({ antwort }: { antwort: AntwortAusserhalb }) {
  const [offen, setOffen] = useState(false)
  const wann = zeitpunkt(antwort.gesendet_am)
  return (
    <div className="ev2-hinweiszeile" style={{ margin: "12px 20px 0" }} data-testid="antwort-ausserhalb-verlauf">
      Beantwortet über das Portal{wann ? ` am ${wann}` : ""} — die gesendete Antwort
      steht nicht im Verlauf dieser Mail.{" "}
      <button
        type="button"
        onClick={() => setOffen(!offen)}
        aria-expanded={offen}
        data-frei
        style={{
          background: "none", border: "none", padding: 0, cursor: "pointer",
          color: "var(--accent-color)", fontSize: "inherit",
        }}
      >
        {offen ? "Antwort zuklappen" : "Antwort anzeigen"}
      </button>
      {offen && (
        <div style={{
          marginTop: 6, whiteSpace: "pre-wrap", maxWidth: "68ch",
          color: "var(--text-primary)",
        }}>
          {antwort.text}
        </div>
      )}
    </div>
  )
}
